export const userData = {
  name: "Alex_Neo",
  avatar: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=150&h=150&fit=crop",
  level: 14,
  xp: 4250,
  nextLevelXp: 5000,
  streak: 12,
  rank: "Cyber Knight",
  energy: 80
};

export const currentPath = {
  title: "Advanced React Patterns",
  progress: 65,
  nodes: [
    { id: 1, title: "Custom Hooks", status: "completed", type: "lesson" },
    { id: 2, title: "Context API Deep Dive", status: "completed", type: "quiz" },
    { id: 3, title: "Render Props", status: "completed", type: "lesson" },
    { id: 4, title: "HOCs vs Hooks", status: "current", type: "boss" },
    { id: 5, title: "Compound Components", status: "locked", type: "lesson" },
    { id: 6, title: "State Machines", status: "locked", type: "project" },
  ]
};

export const leaderboardData = [
  { 
    rank: 1, 
    name: "Sarah_Code", 
    xp: 12400, 
    trend: "up", 
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop" 
  },
  { 
    rank: 2, 
    name: "DevNinja", 
    xp: 11250, 
    trend: "same", 
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop" 
  },
  { 
    rank: 3, 
    name: "Alex_Neo", 
    xp: 4250, 
    trend: "up", 
    avatar: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=150&h=150&fit=crop",
    isMe: true 
  },
  { 
    rank: 4, 
    name: "ByteMe", 
    xp: 3900, 
    trend: "down", 
    avatar: "https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=150&h=150&fit=crop" 
  },
  { 
    rank: 5, 
    name: "QuantumLeap", 
    xp: 3100, 
    trend: "up", 
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop" 
  },
];

export const badges = [
  { id: 1, title: "First Blood", desc: "Complete 1st lesson", icon: "FiTarget", earned: true, date: "2023-10-01" },
  { id: 2, title: "7 Day Streak", desc: "Learn for 7 days straight", icon: "FiZap", earned: true, date: "2023-10-08" },
  { id: 3, title: "React Novice", desc: "Finish React Basics", icon: "FiCode", earned: true, date: "2023-10-15" },
  { id: 4, title: "Bug Squasher", desc: "Pass 5 debugging quizzes", icon: "FiShield", earned: true, date: "2023-11-02" },
  { id: 5, title: "Mastermind", desc: "Score 100% on a Boss level", icon: "FiAward", earned: false, date: null },
  { id: 6, title: "Night Owl", desc: "Complete a lesson after midnight", icon: "FiMoon", earned: false, date: null },
];